/**
 * <FullPanelWrapper 
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './FullPanelWrapper.scss'

class FullPanelWrapper extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.state = {
      scrolled: 0,
    }
  }

  componentDidMount() {
    const {
      onScroll
    } = this.props;

    this.ref.onscroll = ()=> {
      const scrollTop = this.ref.scrollTop;
      if (typeof onScroll === "function") {
        onScroll(scrollTop);
      }
    }
  }
  
  render() {
    const {
      topOffset,
    } = this.props;

    const {
      scrolled
    } = this.state

    return (
      <div className='full-panel-wrapper' ref={(r)=>{if (r) this.ref = r;}}>
        {this.props.children}
      </div>
    )
  }
}

export default FullPanelWrapper;



// WEBPACK FOOTER //
// ./src/components/UI/FullPanelWrapper/index.js